module.exports = __webpack_public_path__ + "assets/images/albom8.3c349704.jpg";